export default __webpack_public_path__ + "media/images/tlg-794c99c3770e5d60fb43c172e448c36c.png";